import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { Narrative } from './components/Narrative';
import { Solution } from './components/Solution';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Checklist } from './components/Checklist';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#FBF8F3] text-[#1c1917] font-sans selection:bg-[#D97757] selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      <main className="max-w-2xl mx-auto px-5 flex flex-col" data-id="element-3">
        <Hero data-id="element-4" />
        <Narrative data-id="element-5" />
        <Solution data-id="element-6" />
        <Modules data-id="element-7" />
        <Bonuses data-id="element-8" />
        <Checklist data-id="element-9" />
        <Testimonials data-id="element-10" />
        <Pricing data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <Footer data-id="element-14" />
      </main>
    </div>;
}